<template>
  <a-modal
    :title="title"
    :width="width"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="关闭">
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">

        <a-form-item label="人员名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-popup
            v-decorator="['workerName', validatorRules.workerName]"
            :trigger-change="true"
            org-fields="realname,username"
            dest-fields="worker_name,worker_no"
            code="user_msg"
            @callback="popupCallback"/>
        </a-form-item>
        <a-form-item label="小组id" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'groupId', validatorRules.groupId]" placeholder="请输入小组id"></a-input>
        </a-form-item>
        <a-form-item label="人员角色" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-dict-select-tag type="list" v-decorator="['workerRole', validatorRules.workerRole]" :trigger-change="true" dictCode="standard_team_worker_role" placeholder="请选择人员角色"/>
        </a-form-item>
        <a-form-item label="禁用状态" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-dict-select-tag type="radio" v-decorator="['delFlag', validatorRules.delFlag]" :trigger-change="true" dictCode="del_flag" placeholder="请选择禁用状态"/>
        </a-form-item>
        <a-form-item label="人员工号" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'workerNo', validatorRules.workerNo]" placeholder="请输入人员工号"></a-input>
        </a-form-item>

      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>

  import { httpAction } from '@/api/manage'
  import pick from 'lodash.pick'
  import { validateDuplicateValue } from '@/utils/util'
  import JDictSelectTag from "@/components/dict/JDictSelectTag"

  export default {
    name: "BusStandardGroupWorkerModal",
    components: { 
      JDictSelectTag,
    },
    data () {
      return {
        form: this.$form.createForm(this),
        title:"操作",
        width:800,
        visible: false,
        model: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        validatorRules: {
          workerName: {rules: [
            {required: true, message: '请输入人员名称!'},
          ]},
          groupId: {rules: [
            {required: true, message: '请输入小组id!'},
          ]},
          workerRole: {rules: [
            {required: true, message: '请输入人员角色!'},
          ]},
          delFlag: {rules: [
            {required: true, message: '请输入禁用状态!'},
          ]},
          workerNo: {rules: [
          ]},
        },
        url: {
          add: "/standardTeam/busStandardGroupWorker/add",
          edit: "/standardTeam/busStandardGroupWorker/edit",
        }
      }
    },
    created () {
    },
    methods: {
      add () {
        this.edit({});
      },
      edit (record) {
        this.form.resetFields();
        this.model = Object.assign({}, record);
        this.visible = true;
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model,'workerName','groupId','workerRole','delFlag','workerNo'))
        })
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'post';
            }
            let formData = Object.assign(this.model, values);
            console.log("表单提交数据",formData)
            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
              that.close();
            })
          }
         
        })
      },
      handleCancel () {
        this.close()
      },
      popupCallback(row){
        this.form.setFieldsValue(pick(row,'workerName','groupId','workerRole','delFlag','workerNo'))
      },

      
    }
  }
</script>